import { memo, useEffect } from "react";
import {
  classNames,
  zodiacBetArr,
  calcMantissa,
  calcHead,
} from "../../../../../tool";
import styles from "../index.module.scss";

// 头尾数
function TWS(props) {
  const { plays, selectPlays, onBet, playOddInfo, firstPlay, secondPlay } =
    props;
  // let betArr = [];

  // if (plays && plays.length && betArr.length === 0) {
  //   let arr = [];
  //   plays.map((item, index) => {
  //     if (index < 5) {
  //       arr[index] = {
  //         ...item,
  //         betArr: calcHead(index, 49),
  //       };
  //     } else {
  //       arr[index] = {
  //         ...item,
  //         betArr: calcMantissa(index - 5, 49),
  //       };
  //     }
  //   });
  //   betArr = arr;
  // }

  return (
    <div className={styles.playContainer}>
      {plays.map((item, index) => {
        const active =
          selectPlays.findIndex((i) => i.code === item.code) !== -1;
        return (
          <div
            key={index}
            className={classNames(
              styles.TWS,
              styles.playItem,
              active ? styles.active : ""
            )}
            onClick={() => onBet(item)}
          >
            <div className={styles.name}>{item.name}</div>
            <div className={styles.odds}>
              {
                playOddInfo[
                  `LHC_${firstPlay.code}_${secondPlay.code || firstPlay.code}${
                    item.code
                  }`
                ]
              }
            </div>
          </div>
        );
      })}
    </div>
  );
}
export default memo(TWS);
